import { defineStore } from 'pinia'

 const useModules = defineStore('modules', {
	state: () => {
		return {
			list: []
		}
	},
	getters: {
		all() {
			return this.list
		}
	},
	actions: {
		setModules(data) {
			this.list = data
		},
		pushModule(item) {
			this.list.push(item)
		}
	}
})

export default useModules